import { render, staticRenderFns } from "./TheIcerik.vue?vue&type=template&id=60c827d3"
import script from "./TheIcerik.vue?vue&type=script&lang=js"
export * from "./TheIcerik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports